import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import { AlertTriangle } from 'lucide-mui';
import ActionDialog from '../globalModals/ActionDialog';
import type { ActionType } from '../globalModals/ActionDialog';

interface RecoveryFailureDialogProps {
  onClose: () => void;
}

const RecoveryFailureDialog: React.FC<RecoveryFailureDialogProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const dialogActions: ActionType[] = [
    {
      key: 'understand',
      label: t('common.done'),
      onClick: onClose,
      variant: 'contained',
      color: 'primary',
    },
  ];

  return (
    <ActionDialog
      open
      title={t('recovery.failure.title')}
      onClose={onClose}
      actions={dialogActions}
      maxWidth="xs"
    >
      <Box sx={{ textAlign: 'center', py: 1 }}>
        <Box sx={{ mb: 2 }}>
          <AlertTriangle
            sx={{
              width: 48,
              height: 48,
              color: '#f59e0b',
              mb: 1.5,
            }}
          />
        </Box>

        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
          {t('recovery.failure.noDataTitle')}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          {t('recovery.failure.noDataDescription')}
        </Typography>

        <Box
          sx={{
            backgroundColor: 'action.hover',
            borderRadius: 2,
            p: 2,
            textAlign: 'left',
          }}
        >
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{ mb: 1, display: 'block' }}
          >
            {t('recovery.failure.quickTips')}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: 'block', mb: 0.5 }}
          >
            {t('recovery.failure.tips.recordTime')}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: 'block', mb: 0.5 }}
          >
            {t('recovery.failure.tips.internet')}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: 'block' }}
          >
            {t('recovery.failure.tips.permissions')}
          </Typography>
        </Box>
      </Box>
    </ActionDialog>
  );
};

export default RecoveryFailureDialog;
